<template>
    <v-layout row wrap align-center
              class="pb-4"
    >
        <labelTopic :class="[classes, {'mr-0': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}]">{{ $t(card_filter.label_text) }}</labelTopic>
        <!-- <labelTopic class="section-label--white-shadow"
                    :class="{'mr-0': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}"
        >{{ $t("Идёт обучение") }}</labelTopic> -->
        <labelTopic :class="{'section-label--grey': !courseData.mandatory}">{{ courseData.mandatory ? $t("Обязательный курс") : $t("Необязательный курс") }}</labelTopic>
        <v-layout row wrap :class="{'mt-3': $vuetify.breakpoint.xs}">
            <v-layout v-if="date_start" :class="{'mt-3 ml-0': $vuetify.breakpoint.smAndDown, 'ml-4': $vuetify.breakpoint.xl}">
                <v-flex xs1 sm2 md1
                        text-xs-right px-2
                >
                    <svg v-svg
                         symbol="schedule"
                         class="study__icon study__icon-grey mr-0"
                         role="presentation"
                    />
                </v-flex>
                <v-flex xs11 sm10 md11
                        ml-2
                >{{ date_start }} - {{ date_end }}</v-flex>

            </v-layout>
            <v-flex d-flex row md4
                    xl2 :class="{'mt-3 ml-0': $vuetify.breakpoint.smAndDown, 'ml-2': $vuetify.breakpoint.mdAndUp}"
            >
                <v-flex xs1 sm2 md1
                        text-xs-right d-block
                >
                    <svg v-svg
                         symbol="series"
                         class="study__icon study__icon-grey mr-0"
                         role="presentation"
                    />
                </v-flex>
                <v-flex xs11 sm10 ml-2>
                    <span>{{ $t(series) }}</span>
                </v-flex>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import labelTopic from '@/components/ui/labels/label_topic';
import {mapGetters} from 'vuex';
export default {
  components: {
    labelTopic,
  },
  props: {
    courseData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('course_info', [
      'course_started',
      'course_completed',
      'test_started',
      'test_finished',
      'lessons_passed',
      'content_mobile_showed',
      'course_name',
      'mandatory',
      'date_start',
      'date_end',
      'series',

    ]),
    ...mapGetters('cards', ['cards', 'get_card_by_id', 'filters']),
    course_status: function() {
      const {course_completed, course_started} = this;
      const courseType = this.$route.query.course_type;

      if (courseType) {
        return courseType;
      }

      if (course_completed) {
        return 'finished';
      }

      return course_started ? 'current' : 'newcourse';
    },
    classes: function() {
      const obj = {
        'newcourse': 'section-label--green',
        'finished' : 'section-label--grey',
        'current'  : 'section-label--white',
      };

      return obj[this.course_status];
    },
    card_filter() {
      return this.filters.find((item)=>item.name===this.course_status);
    },
  },

};
</script>

<style>

</style>
